/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsufficientBalanceInfo } from './InsufficientBalanceInfo';
import {
    InsufficientBalanceInfoFromJSON,
    InsufficientBalanceInfoFromJSONTyped,
    InsufficientBalanceInfoToJSON,
    InsufficientBalanceInfoToJSONTyped,
} from './InsufficientBalanceInfo';
import type { PayCompetitionParticipant } from './PayCompetitionParticipant';
import {
    PayCompetitionParticipantFromJSON,
    PayCompetitionParticipantFromJSONTyped,
    PayCompetitionParticipantToJSON,
    PayCompetitionParticipantToJSONTyped,
} from './PayCompetitionParticipant';

/**
 * 
 * @export
 * @interface PayCompetitionResponse
 */
export interface PayCompetitionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PayCompetitionResponse
     */
    success?: boolean;
    /**
     * 3DS redirect URL (if authentication required)
     * @type {string}
     * @memberof PayCompetitionResponse
     */
    nextAction?: string;
    /**
     * 
     * @type {PayCompetitionParticipant}
     * @memberof PayCompetitionResponse
     */
    participant?: PayCompetitionParticipant;
    /**
     * 
     * @type {InsufficientBalanceInfo}
     * @memberof PayCompetitionResponse
     */
    insufficientBalance?: InsufficientBalanceInfo;
}

/**
 * Check if a given object implements the PayCompetitionResponse interface.
 */
export function instanceOfPayCompetitionResponse(value: object): value is PayCompetitionResponse {
    return true;
}

export function PayCompetitionResponseFromJSON(json: any): PayCompetitionResponse {
    return PayCompetitionResponseFromJSONTyped(json, false);
}

export function PayCompetitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayCompetitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'nextAction': json['nextAction'] == null ? undefined : json['nextAction'],
        'participant': json['participant'] == null ? undefined : PayCompetitionParticipantFromJSON(json['participant']),
        'insufficientBalance': json['insufficientBalance'] == null ? undefined : InsufficientBalanceInfoFromJSON(json['insufficientBalance']),
    };
}

export function PayCompetitionResponseToJSON(json: any): PayCompetitionResponse {
    return PayCompetitionResponseToJSONTyped(json, false);
}

export function PayCompetitionResponseToJSONTyped(value?: PayCompetitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'nextAction': value['nextAction'],
        'participant': PayCompetitionParticipantToJSON(value['participant']),
        'insufficientBalance': InsufficientBalanceInfoToJSON(value['insufficientBalance']),
    };
}

